export default __webpack_public_path__ + "static/integration-bg-b7612fd546956383aeec39f293e63171.svg";